import axios from 'axios'
import { clearAuth } from './auth'

// 接口根地址。生产统一走 443，由 Nginx 反代到 127.0.0.1:3005（3005 已不对公网开放）
// 单独导出，供 el-upload 这类必须写绝对地址的场景复用，避免各处硬编码导致漂移
export const baseURL = 'https://cx-t.com'
// 本地联调时临时改成：'http://127.0.0.1:3099'
// （本机后端：cxt-server 下 node scripts/dev-http.cjs，HTTP 3099，走 SSH 隧道连线上只读库）
// ⚠️ 发版前务必改回 'https://cx-t.com'

const instance = axios.create({
  baseURL,
  withCredentials: true, // 允许跨域传递 cookie （登录）
  timeout: 10000
})

// ---------------------------------------------------------------------------
// 统一处理登录失效
// 后端 token 过期 / 被吊销（tokenVersion 变化）一律返回 HTTP 401。
// 以前各页面只 console.error，用户看到的是「转圈结束、表格空白」，不知道要去重新登录。
// 这里统一清掉本地登录态并回到登录页，同时带上 redirect 参数，登录后能跳回原页面。
// ---------------------------------------------------------------------------
const LOGIN_API = '/api/adminuser/login'
let redirectingToLogin = false

function handleUnauthorized (url) {
  // 登录接口自身的 401 是「账号或密码错误」，绝不能跳转，否则会无限重定向
  if (String(url || '').includes(LOGIN_API)) return

  clearAuth()

  if (redirectingToLogin) return
  if (window.location.pathname === '/') return // 已经在登录页了

  redirectingToLogin = true
  const back = window.location.pathname + window.location.search
  window.location.replace(`/?redirect=${encodeURIComponent(back)}`)
}

instance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      handleUnauthorized(err.config && err.config.url)
    }
    return Promise.reject(err)
  }
)

// 封装 get 请求
export const get = async (url, params = {}) => {
  try {
    // 获取 Token
    const token = localStorage.getItem('token')

    // if (!token) {
    //   throw new Error('Token missing')
    // }

    // 发送请求
    const response = await instance.get(url, {
      params, // 请求的参数
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return response.data // 返回请求的数据
  } catch (err) {
    console.error('请求失败:', err)
    throw err // 抛出错误，前端可以捕获并处理
  }
}

export const post = async (url, data = {}) => {
  try {
    // 获取 Token，可以优化成获取到一个全局状态，而非每次都从localStorage读取
    const token = localStorage.getItem('token')

    // 如果token不存在，可以跳转到登录页面，或者直接返回错误
    // if (!token) {
    //   throw new Error('Token missing')
    // }

    // 发送请求
    const response = await instance.post(url, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })

    return response.data // 返回请求的数据
  } catch (err) {
    // 错误处理
    console.error('请求失败:', err)
    throw err // 抛出错误，前端可以捕获并处理
  }
}

export const patch = async (url, data = {}) => {
  try {
    // 获取 Token
    const token = localStorage.getItem('token')

    // if (!token) {
    //   throw new Error('Token missing')
    // }

    // 发送请求
    const response = await instance.patch(url, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })

    return response.data // 返回请求的数据
  } catch (err) {
    // 错误处理
    console.error('请求失败:', err)
    throw err // 抛出错误，前端可以捕获并处理
  }
}

export const del = async (url, params = {}) => {
  try {
    // 获取 Token
    const token = localStorage.getItem('token')

    // if (!token) {
    //   throw new Error('Token missing')
    // }

    // 发送请求
    const response = await instance.delete(url, {
      params, // 请求的参数
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return response.data // 返回请求的数据
  } catch (err) {
    console.error('请求失败:', err)
    throw err // 抛出错误，前端可以捕获并处理
  }
}

// 上传文件（FormData）。
// 注意：这里刻意不设置 Content-Type —— 一旦设成 application/json，
// axios 会把 FormData 转成 JSON 发出去，后端就收不到文件了；
// 交给浏览器自动带上 multipart/form-data 与 boundary 才是正确做法。
export const upload = async (url, formData) => {
  try {
    const token = localStorage.getItem('token')

    const response = await instance.post(url, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      // 图片上传比普通接口慢，单独放宽超时（其余接口仍是 10s）
      timeout: 60000
    })

    return response.data
  } catch (err) {
    console.error('上传失败:', err)
    throw err
  }
}
